<template>
  <v-container fluid>
    <v-data-table-server
      v-model:options="options"
      dense
      :headers="headers"
      :loading="loading"
      :items="items"
      :items-length="totalItems"
      class="elevation-1"
      disable-sort
      hide-default-footer
      @update:options="updateTable"
    >
      <template #top>
        <v-card-title>
          <v-toolbar flat>
            <v-toolbar-title>Tickets</v-toolbar-title>
          </v-toolbar>
        </v-card-title>
      </template>

      <template #item.created="{ item }">
        {{ createDate(item.created_at) }}
      </template>

      <template #item.description="{ item }">
        <p
          class="text-truncate mb-0"
          style="max-width: 200px"
        >
          {{ item.description }}
        </p>
      </template>

      <template #item.actions="{ item }">
        <v-btn
          x-small
          color="primary"
          class="mr-2"
          @click="openCommentsModal(item)"
        >
          <v-icon
            left
            dark
          >
            mdi-comment-multiple
          </v-icon>
          Comments
        </v-btn>
      </template>
    </v-data-table-server>

    <LoanProCustomerZendeskTicketCommentsModal
      v-model="dialogComments"
      :ticket="selectedTicket"
      :comments="selectedTicketComments"
      :lp-customer-id="$route.params.customer_id"
      @close-modal="closeCommentsModal()"
    />
  </v-container>
</template>

<script>
import { DateTime } from 'luxon';
import dataTableMixin from '@/mixins/dataTableMixin.js';

import LoanProCustomerZendeskTicketCommentsModal from '@/views/LoanProCustomers/Zendesk/LoanProCustomerZendeskTicketCommentsModal.vue';

export default {
  name: 'LoanProCustomerZendesk',

  components: {
    LoanProCustomerZendeskTicketCommentsModal,
  },

  mixins: [dataTableMixin],

  data() {
    return {
      dialogComments: false,
      headers: [
        { title: 'ID', key: 'id' },
        { title: 'Date/Time', key: 'created', width: 180 },
        { title: 'Status', key: 'status' },
        { title: 'Subject', key: 'subject' },
        { title: 'Description', key: 'description' },
        { title: '', key: 'actions' },
      ],
      selectedTicket: {
        id: null,
        description: '',
      },
      selectedTicketComments: [],
    };
  },

  methods: {
    async updateTable() {
      this.loading = true;

      const response = await this.$axios.get(
        `api/v1/loanpro-customer/${this.$route.params.customer_id}/tickets`,
      );

      this.totalItems = response.data.total;
      this.items = (response.data.results || []).map((ticket) => ({
        id: ticket.id,
        created_at: ticket.createdAt || ticket.properties?.createdate,
        status: ticket.properties?.subject ? ticket.status : ticket.properties?.hs_pipeline_stage,
        subject: ticket.properties?.subject || 'Support Ticket',
        description: ticket.properties?.content || '',
      }));
      this.loading = false;
    },
    createDate(date) {
      return DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_MED);
    },
    openCommentsModal(ticket) {
      this.dialogComments = true;
      this.selectedTicket = ticket;

      this.$axios.get(
        `api/v1/loanpro-customer/${this.$route.params.customer_id}/tickets/${ticket.id}/comments`,
      ).then((res) => {
        const { data } = res;

        this.selectedTicketComments = (data.comments || []).map((comment) => ({
          id: comment.id,
          created_at: comment.properties?.hs_timestamp
            ? new Date(parseInt(comment.properties.hs_timestamp, 10)).toISOString()
            : comment.created_at,
          body: comment.properties?.hs_note_body || comment.body || '',
        }));
      });
    },

    closeCommentsModal() {
      this.dialogComments = false;
      this.selectedTicketComments = [];

      this.selectedTicket = {
        id: null,
        description: '',
      };
    },
  },
};
</script>
